
import PermissionConstants
    from "../../configs/PermissionConstants";
import RouteConstants from "../../configs/RouteConstants";

const chartOfAccountPermissions = [PermissionConstants.GROUP_HEADER_VIEW, PermissionConstants.MAIN_GROUP_VIEW, PermissionConstants.SUB_ACCOUNT_VIEW, PermissionConstants.ACCOUNT_VIEW];
const configPermissions = [PermissionConstants.DEPARTMENT_VIEW, PermissionConstants.ZONE_VIEW, PermissionConstants.AREA_VIEW, PermissionConstants.TRANSPORT_TYPE_VIEW, PermissionConstants.FEES_TYPE_VIEW, PermissionConstants.FEES_SETUP_VIEW, PermissionConstants.TRANSACTION_CODE_SETUP_VIEW, PermissionConstants.CLASS_PROMOTION_VIEW, PermissionConstants.FINANCE_TRANSACTION_CODE_SETUP_VIEW, PermissionConstants.MODE_OF_PAY_VIEW, PermissionConstants.CURRENCY_VIEW, PermissionConstants.CUSTOMER_VIEW, PermissionConstants.SUPPLIER_VIEW, PermissionConstants.ACCOUNT_LEDGER_VIEW, PermissionConstants.BANK_DETAIL_VIEW, PermissionConstants.MAIN_GROUP_LEDGER_VIEW, PermissionConstants.CHEQUE_TRANSACTION_SETUP_VIEW, PermissionConstants.CASH_LEDGER_VIEW];

const navConfig = [
    {
        title: 'Companies',
        path: RouteConstants.COMPANIES,
        icon: 'material-symbols:store-rounded',
        permissions: [PermissionConstants.COMPANY_VIEW]
    },
    {
        title: 'Schools',
        path: RouteConstants.SCHOOLS,
        icon: 'teenyicons:school-solid',
        permissions: [PermissionConstants.SCHOOL_VIEW]
    },
    {
        title: 'Roles',
        path: RouteConstants.GROUPS,
        icon: 'material-symbols:group-work',
        permissions: [PermissionConstants.GROUP_VIEW]
    },
    {
        title: 'Users',
        path: RouteConstants.USERS,
        icon: 'ph:users-three-fill',
        permissions: [PermissionConstants.USER_VIEW]
    },
    {
        title: 'Students',
        path: RouteConstants.STUDENTS,
        icon: 'mdi:account-student',
        permissions: [PermissionConstants.STUDENT_VIEW]
    },
    {
        title: 'Invoices',
        path: RouteConstants.INVOICES,
        icon: 'iconamoon:invoice-fill',
        permissions: [PermissionConstants.INVOICE_VIEW]
    },
    {
        title: 'Invoice Deletion',
        path: RouteConstants.INVOICE_DELETION,
        icon: 'mdi:file-excel-outline',
        permissions: [PermissionConstants.INVOICE_VIEW]
    },
    {
        title: 'Receipts',
        path: RouteConstants.RECEIPTS,
        icon: 'fluent:receipt-32-filled',
        permissions: [PermissionConstants.RECEIPT_VIEW]
    },
    {
        title: 'Vouchers',
        path: RouteConstants.VOUCHERS,
        icon: 'mdi:voucher',
        permissions: [PermissionConstants.PAYMENT_VOUCHER_VIEW, PermissionConstants.JOURNAL_VOUCHER_VIEW]
    },
    {
        title: 'SOA',
        path: RouteConstants.JOURNALS,
        icon: 'ooui:journal-ltr',
        permissions: [PermissionConstants.SOA_VIEW]
    },
    {
        title: 'Credit Notes',
        path: RouteConstants.CREDIT_NOTES,
        icon: 'mdi:cash-plus',
        permissions: [PermissionConstants.CREDIT_NOTE_VIEW]
    },
    {
        title: 'Debit Notes',
        path: RouteConstants.DEBIT_NOTES,
        icon: 'mdi:cash-minus',
        permissions: [PermissionConstants.DEBIT_NOTE_VIEW]
    },
    {
        title: 'CSV Upload',
        path: RouteConstants.CSV_UPLOAD,
        icon: 'fa-solid:file-csv',
        permissions: [PermissionConstants.STUDENT_CSV_DOWNLOAD, PermissionConstants.AREA_CSV_DOWNLOAD]
    },
    {
        title: 'Forms',
        path: RouteConstants.FORMS,
        icon: 'fluent:form-20-filled',
        permissions: [PermissionConstants.FORM_VIEW]
    },
    {
        title: 'Discounts',
        path: RouteConstants.DISCOUNTS,
        icon: 'ic:baseline-discount',
        permissions: [PermissionConstants.DISCOUNT_VIEW]
    },
    {
        title: 'Reports',
        path: RouteConstants.REPORTS,
        icon: 'mdi:report-box',
        permissions: [PermissionConstants.DAILY_FEE_REPORT, PermissionConstants.OUTSTANDING_FEE_REPORT]
    },
    {
        title: 'Chart of accounts',
        path: RouteConstants.CHART_OF_ACCOUNTS,
        icon: 'ic:baseline-account-tree',
        permissions: chartOfAccountPermissions,
    },
    {
        title: 'Configurations',
        path: RouteConstants.CONFIGURATIONS,
        icon: 'ant-design:setting-filled',
        permissions: configPermissions
    }
];

export default navConfig;